/** Nome del prodotto nella web app: con `APP_NAME` del server è l'unico punto da cambiare. */
export const APP_NAME = 'Timonio';
